import { render, staticRenderFns } from "./sidebarMenu.vue?vue&type=template&id=e7b5f9ec&scoped=true"
import script from "./sidebarMenu.vue?vue&type=script&lang=js"
export * from "./sidebarMenu.vue?vue&type=script&lang=js"
import style0 from "./sidebarMenu.vue?vue&type=style&index=0&id=e7b5f9ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7b5f9ec",
  null
  
)

export default component.exports